<template>
    <div>
        <div class="tabs-container">
            <div class="container">
                <!-- Nav tabs -->
                <ul class="nav nav-tabs mx-4 d-flex justify-content-between align-items-center" id="myTab" role="tablist">
                    <li class="nav-item d-flex justify-content-center">
                        <a class="nav-link d-flex align-items-center" @click="$event.stopImmediatePropagation(); $event.preventDefault()" 
                            :class="activeTab == 1 ? 'active': 'default'" 
                            href="#home" 
                            id="home-tab" 
                            role="tab" 
                            data-toggle="tab" 
                            aria-controls="home" 
                            aria-selected="true"
                        >
                            <div class="circle-number d-flex justify-content-center align-items-center mr-2">
                                <span>1</span>
                            </div>
                            <div><span>Afíliese gratis</span></div>
                        </a>
                    </li>
                    <li class="nav-item d-flex justify-content-center">
                        <a class="nav-link d-flex align-items-center" @click="$event.stopImmediatePropagation(); $event.preventDefault()" 
                            :class="activeTab == 2 ? 'active': 'default'" 
                            href="#profile" 
                            id="profile-tab" 
                            role="tab" 
                            data-toggle="tab" 
                            aria-controls="profile" 
                            aria-selected="false"
                        >
                            <div class="circle-number d-flex justify-content-center align-items-center mr-2">
                                <span>2</span>
                            </div>
                            <div><span>Información personal</span></div>
                        </a>
                    </li>
                    <li class="nav-item d-flex justify-content-center">
                        <a class="nav-link d-flex align-items-center" @click="$event.stopImmediatePropagation(); $event.preventDefault()" 
                            :class="activeTab == 3 ? 'active': 'default'" 
                            href="#messages" 
                            id="messages-tab" 
                            role="tab" 
                            data-toggle="tab" 
                            aria-controls="messages" 
                            aria-selected="false"
                        >
                            <div class="circle-number d-flex justify-content-center align-items-center mr-2">
                                <span>3</span>
                            </div>
                            <div><span>Información de envío de paquetes en Costa Rica</span></div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="tab-content" ref="registerForm">
            <step1 v-if="!successRegistering" :personalAccount="personalAccount" :enterpriseAccount="enterpriseAccount" :activeTab="activeTab" :Consignee="Consignee" :extraParams="otherParameters" @updateConsignee="onStepUpdate" @updateAccount="onAccountUpdate"></step1>
            <step2 v-if="!successRegistering" :personalAccount="personalAccount" :enterpriseAccount="enterpriseAccount" :activeTab="activeTab" :Consignee="Consignee" :extraParams="otherParameters" @updateConsignee="onStepUpdate" @updateAccount="onAccountUpdate"></step2>
            <step3 v-if="!successRegistering" :personalAccount="personalAccount" :enterpriseAccount="enterpriseAccount" :activeTab="activeTab" :Consignee="Consignee" :extraParams="otherParameters" @updateConsignee="onStepUpdate" @updateAccount="onAccountUpdate"></step3>
            <div class="splash-container" v-if="successRegistering">
                <figure>
                    <img src="/wp-content/uploads/2018/10/page-icon.png" alt="">
                </figure>
                <div class="splash-info">
                    <div >
                        <h2>Cuenta registrada correctamente!</h2>
                        <button class="default-green" @click="redirectLogin">Ingresar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import queryString from 'query-string'
import Step1 from './components/registerStep1.vue'
import Step2 from './components/registerStep2.vue'
import Step3 from './components/registerStep3.vue'
import * as CrboxApi from '../services/CrboxApi.js'
/* eslint-disable */
export default {
  context: 'register context',
  name: 'Register',
  components: {
      Step1,
      Step2,
      Step3
  },
  data: () => {
    return {
        personalAccount: true,
        enterpriseAccount: false,
        successRegistering: false,
        Consignee: {
            ConsigneeName: '',
            ConsigneeLastName1: '',
            ConsigneeLastName2: '',
            Email: '',
            BirthDate: '',
            IdentificationType: '',
            IdentificationNumber: '',
            AlternativeEmail: '',
            ResidenceCountry: '',
            IdSucursal: 1,
            ContactName1: '',
            ContactName2: '',
            IsCompany: false,
            ReceivesNewsletter: true,
            Responsabilidad: '',
            IdResponsabilidad: ''
        },
        otherParameters: {
            confirmEmail: '',
            password: '',
            ConfirmPassword: '',
            companyCode: '',
            phones: [],
            addresses: []
        },
        activeTab: 1,
        emptyFields: false 
    }
  },
  methods: {
    redirectLogin() {
        window.location.href = '/client';
    },
    login: function () {
      console.log(this.rememberMe);
      this.$auth.login({
            data: queryString.stringify({
              grant_type: "password",
              username: this.user.username,
              password: this.user.password
            }),
            rememberMe: this.rememberMe,
            success: function (res) {
              this.$auth.user({email: this.user.username});
            },
            error: function () {
              
            }
        });
    },
    onStepUpdate(data){
        this.Consignee = data.consignee;
        this.otherParameters = data.params;
        if(this.activeTab == 3){
            let loader = this.$loading.show({
                container: this.$refs.registerForm
            });
            CrboxApi.postRegisterUser(this, this.Consignee, this.otherParameters.confirmEmail, this.otherParameters.password, this.otherParameters.ConfirmPassword, this.otherParameters.companyCode, this.otherParameters.phones, this.otherParameters.addresses)
                .then((response) => {
                    if(response.data.StatusResult == "OK"){
                        this.$notify({
                            group: 'notifications',
                            type: 'success',
                            title: 'Registro',
                            text: "El usuario ha sido registrado",
                            duration: 4000,
                            speed: 1000
                        });
                        this.successRegistering = true;
                    }else if(response.data.StatusResult == 'ERROR'){
                        this.$notify({
                            group: 'notifications',
                            type: 'warn',
                            title: 'Registro',
                            text: response.data.Message,
                            duration: 4000,
                            speed: 1000
                        })
                        this.activeTab = 1;
                    }
                    loader.hide();
                })
                .catch(() => {
                    this.$notify({
                        group: 'notifications',
                        type: 'error',
                        title: 'Registro',
                        text: "Ha ocurrido un error al registrar el usuario, por favor contactenos a servicioalcliente@crbox.cr",
                        duration: 7000,
                        speed: 1000
                    })
                    this.activeTab = 1;
                    loader.hide();                    
                })
        }
        this.activeTab++;
        console.log(this.Consignee);
        console.log(this.otherParameters);
    },
    onAccountUpdate(data){
        this.personalAccount = data.personalAccount;
        this.enterpriseAccount = data.enterpriseAccount;
        this.Consignee.IsCompany = this.enterpriseAccount;
    }
    /*validateEmptyFields: function(event, el) {
        event.preventDefault();
        var inputs = el.querySelectorAll('input');
        inputs.forEach((input) => {
            if(input.value == '' || input.value == undefined){
                var checkIfErrorExist = input.parentNode.querySelectorAll('.input-empty-error');
                if(checkIfErrorExist.length == 0){
                    var error = document.createElement('p');
                    error.innerHTML = '*Este campo es requerido';
                    error.classList.add('input-empty-error');
                    input.parentNode.appendChild(error);
                }
            }
            else{
                var error =  input.parentNode.querySelectorAll('.input-empty-error');
                if (typeof(error) != 'undefined' && error != null)
                {
                    input.parentNode.childNodes.forEach((child) => {
                        if(child.classList.contains('input-empty-error')){
                            input.parentNode.removeChild(child);
                        }
                    })
                }
            }
        });
    }*/
  }
}
</script>